import { useEffect, useState } from 'react';
import SectionLink from './SectionLink';
import { BUSINESS } from '../site';

const links = [
  { label: 'Home', section: undefined },
  { label: 'Services', section: 'services' },
  { label: 'Why Us', section: 'why-choose-us' },
  // Restore with the testimonials section: { label: 'Reviews', section: 'reviews' },
  { label: 'Contact', section: 'contact' },
];

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMenu = () => setMobileMenuOpen(false);

  const navHeight = scrolled ? 'clamp(72px, 7vw, 88px)' : 'clamp(84px, 9vw, 116px)';
  const logoHeight = scrolled ? 'clamp(48px, 5.5vw, 64px)' : 'clamp(60px, 7.5vw, 96px)';
  const navLinkSize = scrolled ? 'clamp(13px, 1vw, 15px)' : 'clamp(16px, 1.3vw, 18px)';

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md transition-all duration-300"
      style={{
        background: scrolled ? '#ffffff' : 'rgba(255,255,255,0.92)',
        boxShadow: scrolled ? '0 4px 20px -8px rgba(16,24,40,0.15)' : 'none',
      }}
    >
      <div
        className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between gap-4 transition-all duration-300"
        style={{ height: navHeight }}
      >
        {/* Logo */}
        <SectionLink onNavigate={closeMenu} className="flex-shrink-0 cursor-pointer flex items-center" aria-label="Flip Ready home">
          <img
            src="/logo.webp"
            alt="Flip Ready Cleaning Services logo"
            width={480}
            height={279}
            className="w-auto max-w-[240px] transition-all duration-300"
            style={{ height: logoHeight }}
          />
        </SectionLink>

        {/* Desktop Navigation */}
        <div className="max-[1100px]:hidden flex items-center gap-9">
          {links.map((link) => (
            <SectionLink
              key={link.label}
              section={link.section}
              className="text-gray-700 hover:text-[#0b5b96] transition-colors duration-200 font-semibold whitespace-nowrap cursor-pointer"
              style={{ fontSize: navLinkSize }}
            >
              {link.label}
            </SectionLink>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="max-[1100px]:hidden flex items-center gap-5">
          <a
            href={BUSINESS.phoneHref}
            className="font-bold text-[#0b5b96] hover:text-[#0b5b96] transition-colors duration-200 whitespace-nowrap cursor-pointer"
            style={{ fontSize: 'clamp(15px, 1.3vw, 18px)' }}
          >
            {BUSINESS.phoneDisplay}
          </a>
          <SectionLink
            section="contact"
            className="bg-[#0b5b96] hover:bg-[#084876] text-white px-[26px] py-[11px] rounded-full font-bold text-[15px] transition-all duration-200 shadow-[0_8px_18px_-8px_rgba(11,91,150,0.55)] hover:shadow-[0_10px_22px_-8px_rgba(11,91,150,0.6)] hover:-translate-y-px whitespace-nowrap cursor-pointer"
          >
            Get Quote
          </SectionLink>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="min-[1100px]:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
          aria-label="Menu"
          aria-expanded={mobileMenuOpen}
        >
          <div className="w-6 h-[18px] flex flex-col justify-between">
            <span className={`w-full h-0.5 bg-gray-700 rounded-sm transition-all ${mobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
            <span className={`w-full h-0.5 bg-gray-700 rounded-sm transition-all ${mobileMenuOpen ? 'opacity-0' : ''}`}></span>
            <span className={`w-full h-0.5 bg-gray-700 rounded-sm transition-all ${mobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
          </div>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="min-[1100px]:hidden border-t border-gray-200 bg-white shadow-lg px-6 pt-5 pb-7 flex flex-col gap-1">
          {links.map((link) => (
            <SectionLink
              key={link.label}
              section={link.section}
              onNavigate={closeMenu}
              className="text-left py-3 px-1 text-base font-semibold text-gray-700 cursor-pointer"
            >
              {link.label}
            </SectionLink>
          ))}
          <a href={BUSINESS.phoneHref} className="py-3 px-1 font-bold text-[#0b5b96]">
            Call {BUSINESS.phoneDisplay}
          </a>
          <SectionLink
            section="contact"
            onNavigate={closeMenu}
            className="mt-2 bg-[#0b5b96] text-white p-[14px] rounded-full font-bold text-base text-center cursor-pointer"
          >
            Get Free Quote
          </SectionLink>
        </div>
      )}
    </nav>
  );
}
